import { LeaderboardBadge } from "@/components/LeaderboardBadge";
import { useLeaderboardPosition } from "@/hooks/useLeaderboardPosition";

/**
 * Component to display a username with leaderboard badge if in top 10
 */
export function UsernameWithBadge({ userId, username, className = "" }) {
  const { data: position } = useLeaderboardPosition(userId);

  return (
    <span className={`flex items-center ${className}`}>
      {username}
      {position && <LeaderboardBadge position={position} />}
    </span>
  );
}

